import { Link } from 'react-router';
import { ChevronRight } from 'lucide-react';

export function Onboarding() {
  return (
    <div className="min-h-screen bg-primary text-white flex flex-col p-6 relative overflow-hidden">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-accent rounded-full blur-[120px] opacity-20 pointer-events-none"></div>

      <div className="flex justify-center gap-2 py-6 relative z-10">
        <div className="w-3 h-3 bg-white rounded-full"></div>
        <div className="w-3 h-3 bg-white/30 rounded-full"></div>
        <div className="w-3 h-3 bg-white/30 rounded-full"></div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center relative z-10">
        <div className="w-72 h-72 bg-white rounded-full flex items-center justify-center mb-8 shadow-[0_8px_32px_rgba(0,0,0,0.12)] relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-background to-card"></div>

          <svg width="180" height="200" viewBox="0 0 180 200" className="relative z-10">
            <circle cx="90" cy="45" r="22" fill="#003B4A" opacity="0.15" />
            <circle cx="90" cy="45" r="18" fill="#003B4A" />

            <ellipse cx="90" cy="120" rx="35" ry="50" fill="#0E7A8A" opacity="0.2" />

            <path
              d="M 90 70 Q 85 80 75 85 L 60 95 Q 55 100 52 110"
              fill="none"
              stroke="#003B4A"
              strokeWidth="4"
              strokeLinecap="round"
            />

            <path
              d="M 90 70 Q 80 75 65 70"
              fill="none"
              stroke="#FF5533"
              strokeWidth="3.5"
              strokeLinecap="round"
              opacity="0.8"
            />

            <circle cx="52" cy="110" r="5" fill="#003B4A" />

            <path
              d="M 90 70 Q 95 80 105 85 L 120 95"
              fill="none"
              stroke="#003B4A"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <circle cx="120" cy="95" r="5" fill="#003B4A" />

            <path
              d="M 90 100 L 75 160"
              stroke="#003B4A"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <path
              d="M 90 100 L 105 160"
              stroke="#003B4A"
              strokeWidth="4"
              strokeLinecap="round"
            />

            <circle cx="75" cy="160" r="5" fill="#003B4A" />
            <circle cx="105" cy="160" r="5" fill="#003B4A" />

            <path
              d="M 50 70 Q 65 65 75 68"
              fill="none"
              stroke="#FF5533"
              strokeWidth="2"
              strokeLinecap="round"
              opacity="0.4"
              strokeDasharray="3 3"
            />
          </svg>
        </div>

        <h1 className="text-3xl text-center mb-6 font-bold">Bienvenida, María</h1>

        <p className="text-white/90 text-center max-w-xs mb-4">
          Dr. Martínez te asignó un plan de recuperación.
        </p>

        <p className="text-white/90 text-center max-w-xs mb-8">
          Vamos a acompañarte en cada sesión con tu cámara — sin sensores, sin accesorios.
        </p>

        <div className="bg-white rounded-3xl p-6 w-full max-w-sm shadow-[0_8px_24px_rgba(0,0,0,0.15)]">
          <div className="text-xs text-primary tracking-[0.08em] uppercase font-semibold mb-4">Necesitás</div>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="w-1.5 h-1.5 bg-primary rounded-full mt-2 flex-shrink-0"></div>
              <span className="text-foreground">Un teléfono con cámara</span>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-1.5 h-1.5 bg-primary rounded-full mt-2 flex-shrink-0"></div>
              <span className="text-foreground">2 metros de espacio libre</span>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-1.5 h-1.5 bg-primary rounded-full mt-2 flex-shrink-0"></div>
              <span className="text-foreground">Ropa cómoda</span>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-4 relative z-10">
        <Link
          to="/paciente-home"
          className="flex items-center justify-center gap-2 w-full bg-accent text-accent-foreground py-4 rounded-full text-center font-semibold shadow-[0_4px_12px_rgba(255,85,51,0.3)] transition-all duration-200 ease-out hover:shadow-[0_6px_16px_rgba(255,85,51,0.4)] hover:scale-[1.02]"
        >
          Empezar
          <ChevronRight className="w-5 h-5" strokeWidth={1.5} />
        </Link>
        <button className="w-full text-white/70 text-sm transition-all duration-200 ease-out hover:text-white">
          Saltar
        </button>
      </div>
    </div>
  );
}
